import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Row, Col } from 'pui-react-grids'
import CategoryCard from '../common/CategoryCard'
import { getWorldsWithCategories } from '../selectors'
import Footer from '../common/Footer'

import withStyles from 'material-ui-next/styles/withStyles'

const styles = {
  worldTitle: {
    textTransform: 'uppercase',
    fontWeight: 'normal',
    paddingLeft: 10,
  },
}

class Home extends PureComponent {
  render() {
    const { classes } = this.props
    return (
      <div className="padding padding-no-top">
        {this.props.worlds.map(world => (
          <div key={world.id}>
            <Row>
              <h5 className={classes.worldTitle}>{world.nome}</h5>
            </Row>
            <Row>

              {world.categories.map(category => (
                <Col key={category.id} lg={6} md={8} sm={12} xs={24}>
                  <Link to={`/category/${category.slug}`} key={category.id}>
                    <CategoryCard category={category} />
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        ))}
        <Footer />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    worlds: getWorldsWithCategories(state),
  }
}

export default withStyles(styles)(connect(mapStateToProps)(Home))



// WEBPACK FOOTER //
// ./src/pages/Home.js